/**
 * Show google map with clickable lat long point for choosing a start point etc
 */
admin.registerLoad(function (prefix) {

    $(prefix + '.latlng-map').each(function () {
        var $this = $(this);
        var lat = $('#' + $this.data('latitude'));
        var lng = $('#' + $this.data('longitude'));
        var postcode = $('#' + $this.data('postcode'));
        var town = $('#' + $this.data('town'));
        var county = $('#' + $this.data('county'));

        if (lat.val() == "" || lng.val() == "") {
            if ($this.data('default-latitude')) {
                lat.val($this.data('default-latitude'));
            } else {
                lat.val(53.485);
            }

            if ($this.data('default-longitude')) {
                lng.val($this.data('default-longitude'));
            } else {
                lng.val(-2.194);
            }
        }

        var point = new google.maps.LatLng(lat.val(), lng.val());

        var mapOptions = {
            center: point,
            zoom: parseInt(14),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }

        var map = new google.maps.Map($(this)[0], mapOptions);

        /*map.addListener('center_changed', function() {
         lat.val(map.getCenter().lat());
         lng.val(map.getCenter().lng());
         });*/

        var marker = new google.maps.Marker({
            draggable: false,
            animation: google.maps.Animation.DROP,
            position: point
        });

        marker.setMap(map);

        google.maps.event.addListener(map, 'click', function (event) {
            latlng_changed($this, marker, map, event);
        });

        google.maps.event.addListener(marker, 'dragend', function (event) {
            latlng_changed($this, marker, map, event);
        });

        var parent = $(this);

        while (parent.length > 0) {
            if (parent.hasClass('tab-pane')) {
                $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(new google.maps.LatLng(lat.val(), lng.val()));
                });
                break;
            }
            parent = parent.parent();
        }

        lng.change(function () {
            fields_changed();
        });

        lat.change(function () {
            fields_changed();
        });

        if ($this.data("route-url")) {
            setup_map_overlay(map, $this.data("route-url"));
        }

        function fields_changed() {
            var point = new google.maps.LatLng(lat.val(), lng.val());
            marker.setPosition(point);
            map.setCenter(point);
        }

        postcode.change(function () {

            var address = $(this).val();
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': address}, function postcodesearch(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var latitude = results[0].geometry.location.lat();
                    var longitude = results[0].geometry.location.lng();

                    lat.val(latitude.toFixed(6));
                    lng.val(longitude.toFixed(6));

                    fields_changed();

                    for (var i = 0; i < results[0].address_components.length; i++) {
                        var comp = results[0].address_components[i];
                        var name = results[0].address_components[i].long_name;

                        // try to find a count option from any of the fields
                        county.find("option").each(function () {
                            if ($(this).text().toLowerCase() == name.toLowerCase()) {
                                county.val(parseInt($(this).attr('value')));
                                county.trigger("chosen:updated");
                            }
                        });

                        if (comp.types[0] == "postal_town") {
                            town.val(name);
                        }

                        if (comp.types[0] == "postal_code") {
                            postcode.val(name);
                        }
                    }

                }
                else {
                    //alert("Error");
                }
            });
        });
    });

    function latlng_changed($this, marker, map, event) {
        // create or move marker
        if (marker) {
            marker.setPosition(event.latLng);
        } else {
            marker = new google.maps.Marker({
                position: event.latLng,
                draggable: true,
                animation: google.maps.Animation.DROP
            });

            marker.setMap(map);
        }

        var lat = $('#' + $this.data('latitude'));
        var lng = $('#' + $this.data('longitude'));
        var postcode = $('#' + $this.data('postcode'));
        var town = $('#' + $this.data('town'));
        var county = $('#' + $this.data('county'));

        lat.val(event.latLng.lat().toFixed(6));
        lng.val(event.latLng.lng().toFixed(6));

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'location': event.latLng}, function postcodesearch(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                for (var i = 0; i < results[0].address_components.length; i++) {
                    var comp = results[0].address_components[i];
                    var name = results[0].address_components[i].long_name;

                    // try to find a count option from any of the fields
                    county.find("option").each(function () {
                        if ($(this).text().toLowerCase() == name.toLowerCase()) {
                            county.val(parseInt($(this).attr('value')));
                            county.trigger("chosen:updated");
                        }
                    });

                    if (comp.types[0] == "postal_town") {
                        town.val(name);
                    }

                    if (comp.types[0] == "postal_code") {
                        postcode.val(name);
                    }
                }

            }
            else {
                //alert("Error");
            }
        });
    }

    function setup_map_overlay(map, routeURL) {
        var settings = {
            // These are the defaults.
            strokecolor: '#ff0000',
            strokeopacity: 0.7,
            strokeweight: 2,
            start: '//maps.google.com/mapfiles/ms/icons/green-dot.png',
            end: '//maps.google.com/mapfiles/ms/icons/red-dot.png',
            elevation: null,
            missing: '/images/route/map_missing.jpg',
            controls: false,
            json: ''
        };

        $.ajax({
            type: 'GET',
            url: routeURL,
            dataType: 'json',
            crossOrigin: true,
            success: function (data) {
                var points = [];
                var bounds = new google.maps.LatLngBounds();

                for (var offset in data) {
                    var point = data[offset];
                    var p = new google.maps.LatLng(point.lat, point.lng);
                    points.push(p);
                    bounds.extend(p);
                }


                var poly = new google.maps.Polyline({
                    // use your own style here
                    path: points,
                    strokeColor: settings.strokecolor,
                    strokeOpacity: settings.strokeopacity,
                    strokeWeight: settings.strokeweight
                });

                poly.setMap(map);

                // fit bounds to track
                //map.fitBounds(bounds);

                // need to add start and end points to the map here if they are specified in the options
                if (settings.start.length > 1) {
                    var startPos = {lat: data[0].lat, lng: data[0].lng};
                    var startMarker = new google.maps.Marker({
                        position: startPos,
                        map: map,
                        title: 'Start'
                    });
                    startMarker.setIcon(settings.start);
                }


                if (settings.end.length > 1) {
                    var endPos = {lat: data[data.length - 1].lat, lng: data[data.length - 1].lng};
                    var endMarker = new google.maps.Marker({
                        position: endPos,
                        map: map,
                        title: 'End'
                    });
                    endMarker.setIcon(settings.end);
                }
            },
            error: function (data) {

            }
        });
    }
});
